import "./style.less";

export default function SearchBarTime() {
    return {
        restrict: "E",
        //require : '^searchBar',
        template: require("./template.html")

        // link: function(scope, element, attrs, $ctrl) {
        //     //console.log( $ctrl );
        // },
        // controller: function($scope, searchBarFactory) {
        //     /**
        //      * CONTROLLER SHARES $SCOPE WITH SEARCH-BAR.JS
        //      */
        // }
    };
}
